import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.bar.winloses;

export const barWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
